var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLms360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none;}.cls-2{fill:#ed1869;}.cls-3{fill:#3d55a5;}.cls-4{fill:#18b575;}.cls-5{fill:#fdbc42;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.07,
    y: 31.07,
    width: 187.87,
    height: 187.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LMS360"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.15,48.14V150.78a23.67,23.67,0,0,0,7.67,16.92H39.09a8,8,0,0,1-8-8V52a3.86,3.86,0,0,1,3.86-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,65.22H48a23.72,23.72,0,0,0-17,7.67V52.14a4,4,0,0,1,4-4H213.55a5.38,5.38,0,0,1,5.38,5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.85,167.7V65.07a23.67,23.67,0,0,0-7.67-16.93h20.76a4,4,0,0,1,4,4V163.71a4,4,0,0,1-4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.07,150.61H202a23.61,23.61,0,0,0,17-7.67v20.77a4,4,0,0,1-4,4H35.06a4,4,0,0,1-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.15,135.06v15.67a23.77,23.77,0,0,0,7.67,17H35.07a4,4,0,0,1-4-4V138.92a3.86,3.86,0,0,1,3.86-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.61,100.79,129.29,76.72a9.17,9.17,0,0,0-8.58,0L75.39,100.79a4.44,4.44,0,0,0-.08,7.8L89,116.22a.89.89,0,0,0,1.33-.78h0a15.93,15.93,0,0,1,15.89-15.88h36.56a15.93,15.93,0,0,1,15.89,15.88h0a1.23,1.23,0,0,0,1.83,1.07l14.2-7.92A4.44,4.44,0,0,0,174.61,100.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.37,103.6h40a9.75,9.75,0,0,1,9.75,9.75V130a10.19,10.19,0,0,1-10.19,10.19H104.8A10.19,10.19,0,0,1,94.62,130V113.35A9.75,9.75,0,0,1,104.37,103.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 82.3,
    y: 189.72,
    width: 85.39,
    height: 12.14,
    rx: 5.07
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLms360);
export default __webpack_public_path__ + "static/media/lms360.ee451937f20d0d1f4e942cdf8eec0a1b.svg";
export { ForwardRef as ReactComponent };